import React from 'react';
import "./CopyIcon.scss";
import ToolTipIcon from './ToolTipIcon';

export default function CopyIcon(props) {	
	return (
		<ToolTipIcon icon="link" title="Copy link" classPrefix="copy" onClick={() => {navigator.clipboard.writeText(props.link)}} />
	);
}